var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteTyne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5h10M11.89 5v7c0 .265-.118.52-.326.707a1.177 1.177 0 0 1-.786.293H5.222c-.294 0-.577-.105-.785-.293A.952.952 0 0 1 4.11 12V5m1.667 0V4c0-.265.117-.52.325-.707.209-.188.491-.293.786-.293h2.222c.295 0 .578.105.786.293a.952.952 0 0 1 .325.707v1",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteTyne);
export default __webpack_public_path__ + "static/media/deleteTyne.9c71cbc1db3352b2dd486d98fe268f8c.svg";
export { ForwardRef as ReactComponent };